import { getBranchesList } from 'redux/modules/branches/actions/get-branches-list';

export const branchList = () => dispatch => dispatch(getBranchesList());
